import React, { useState, useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import debounce from 'lodash.debounce';
import { toast } from 'react-toastify';
import API from '../../../../../utils';

function TechnologyAnalysis() {
    const [checkedValue, setCheckedValue] = useState({ technology_analysis: '' });
    const [updatedTask, setUpdatedTask] = useState(null);
    const uid = localStorage.getItem("user_id");

    const fetchData = async () => {
        try {
            const formDataToSend = new FormData();
            formDataToSend.append('user_id', uid);

            const response = await axios.post(`${API.BASE_URL}${API.ENDPOINTS.get_growth_technology}`, formDataToSend, {
                headers: {
                    Authorization: `${API.AUTHORIZATION_TOKEN}`,
                },
            });

            if (response.data.status === "success") {
                setCheckedValue(response.data.data || { technology_analysis: '' });
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error('Fetch technology data error', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const debouncedUpdateTask = useCallback(
        debounce(async (task) => {
            const formDataToSend = new FormData();
            formDataToSend.append('user_id', uid);
            formDataToSend.append('analysis', task.value || '');

            try {
                const response = await axios.post(
                    `${API.BASE_URL}${API.ENDPOINTS.add_update_technology_analysis}`,
                    formDataToSend,
                    {
                        headers: {
                            Authorization: `${API.AUTHORIZATION_TOKEN}`,
                        },
                    }
                );

                if (response.data.status === "success") {
                    toast.success(response.data.message);
                    fetchData();
                } else {
                    toast.error(response.data.message);
                }
            } catch (error) {
                toast.error("An error occurred while updating data.");
            }
        }, 1000),
        [uid]
    );

    useEffect(() => {
        if (updatedTask) {
            debouncedUpdateTask(updatedTask);
        }
    }, [updatedTask, debouncedUpdateTask]);



    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;

        setCheckedValue({
            technology_analysis: checked ? value : ''
        });

        setUpdatedTask({
            value: checked ? value : ''
        });
    };

    return (
        <div className="col-sm-12">
            <div className="card mt-4">
                <div className="card-header">
                    <div className='justify-content-between d-flex'>
                        <div className="">
                            <h5>Technology Analysis</h5>
                        </div>
                        <div>
                            <Link className='backto-ondriver' to="/growthframeworks/founderdriver">Back to the Founder OS Drivers of Growth</Link>
                        </div>
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="card-body">
                        <div className="founderdriers mb-3" style={{ backgroundColor: checkedValue.technology_analysis === 'Enterprise' ? '#d3f9d8' : 'white' }}>
                            <label><b>
                                <input
                                    className="checkbox_animated"
                                    type="checkbox"
                                    value="Enterprise"
                                    checked={checkedValue.technology_analysis === 'Enterprise'}
                                    onChange={handleCheckboxChange}
                                />
                                <strong>Maturity Level: Enterprise</strong>
                            </b></label>
                            <ul>
                                <li>
                                    <p className="textnots-text">
                                        • Digital is a key driver of customer value and business strategy and this innovation has redefined the business model and the products and services offered.
                                    </p>
                                </li>
                            </ul>
                        </div>

                        <div className="founderdriers mb-3" style={{ backgroundColor: checkedValue.technology_analysis === 'Corporation' ? '#d3f9d8' : 'white' }}>
                            <label><b>
                                <input
                                    className="checkbox_animated"
                                    type="checkbox"
                                    value="Corporation"
                                    checked={checkedValue.technology_analysis === 'Corporation'}
                                    onChange={handleCheckboxChange}
                                />
                                <strong>Maturity Level: Corporation</strong>
                            </b></label>
                            <ul>
                                <li>
                                    <p className="textnots-text">
                                        • The business embraces digital channels, analytics and other digital technologies to benefit the company and its customers.
                                    </p>
                                </li>
                            </ul>
                        </div>

                        <div className="founderdriers mb-3" style={{ backgroundColor: checkedValue.technology_analysis === 'Startup' ? '#d3f9d8' : 'white' }}>
                            <label><b>
                                <input
                                    className="checkbox_animated"
                                    type="checkbox"
                                    value="Startup"
                                    checked={checkedValue.technology_analysis === 'Startup'}
                                    onChange={handleCheckboxChange}
                                />
                                <strong>Maturity Level: Startup</strong>
                            </b></label>
                            <ul>
                                <li>
                                    <p className="textnots-text">
                                        • Technology is leveraged in core functions.
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TechnologyAnalysis;
